export default "__VITE_ASSET__BklwtmJg__"